module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxBAMAAABucDcRAAAAKlBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHrpZrAAAADXRSTlMAEPAwndBgtuBvgEYgTWvsWQAAAIJJREFUOMtjYKAB4FEywC7BdfcadglG3bsTsMscvXsFh5bYu4XYZVjuXhXALuN7txm7BNvdSzicvAmXk5mHk5NFcTq5lnQnryXdyb53FbGKc+LS4Xs3EKu4+N3rAjiC3gGrBou7t3CFVQJWidy72qNOJdepPLicyonDqQw8HQZElTkAX4pMS0RVZ6AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard2/assest/images/dashboard_banner_arrow_icon.png
// module id = M/YO
// module chunks = 0